import React, { useState } from 'react';
import styled from 'styled-components';
const FormContainer = styled.div.attrs({
    className: 'fluid-multi-field-form-container'
}) `
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  border: 1px solid #e1e5e9;
`;
const ListContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const ListItem = styled.button `
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;
  
  &:hover:not(:disabled) {
    border-color: #f97316;
    background: #fff7ed;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
const LetterLabel = styled.span `
  color: #6b7280;
  font-size: 14px;
  font-weight: 600;
  margin-right: 12px;
  min-width: 24px;
  text-align: center;
`;
const ItemText = styled.span `
  color: #374151;
  font-size: 14px;
  flex: 1;
`;
export const SelectListMessage = ({ field, onSelect, options, readOnly, isLoading = false }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleItemClick = async (selectedLabel) => {
        setIsSubmitting(true);
        try {
            await onSelect(selectedLabel);
        }
        finally {
            // @TODO: FLU-193 Handle this.
            setIsSubmitting(false);
        }
    };
    return (React.createElement(FormContainer, { className: "fluid-multi-field-form-container" },
        React.createElement(ListContainer, { style: { marginBottom: '0' } }, options.map((option, optionIndex) => (React.createElement(ListItem, { key: optionIndex, onClick: () => handleItemClick(option.label), disabled: isSubmitting || isLoading || readOnly },
            React.createElement(LetterLabel, null,
                String.fromCharCode(65 + optionIndex),
                "."),
            React.createElement(ItemText, null, option.label)))))));
};
